

<div class="address_book address_modal tab_content" id="content8" data-tab="8" style="position:relative;">







<div class="acquisition_top" style="display:block; margin-bottom: 1rem;" >
  <!-- top left part  -->

<h2 class="heading">Search Address Book <span class="ti-close" (click)="onClose()" style="cursor: pointer;"></span></h2>
  <!-- top right part -->

  <div class="filter_search">
    <div class="search_container">
      <input type="text"  #search class="default_input search search_land" placeholder="Search" />
      <i class="ti-search"></i>
    </div>

    <span class=" filter"><mat-checkbox (change)="OnChange($event)"></mat-checkbox></span>
    <button class="default_secondary-btn Add_new" (click)="createAddressBook()">New Address Book<i class="ti-plus"></i></button>

    <div class="toggle_view" style="position:unset;">
      <mat-button-toggle-group
    name="fontStyle"
    aria-label="Font Style"
    color="accent"
    class="m-3"

    >
    <mat-button-toggle value="list" color="accent" (click)="onList()"
      ><mat-icon class="example-tab-icon"
        >list</mat-icon
      ></mat-button-toggle
    >
    <mat-button-toggle value="grid" (click)="onGrid()"
      ><mat-icon class="example-tab-icon"
        >view_module</mat-icon
      ></mat-button-toggle
    >
    </mat-button-toggle-group>
    </div>
  </div>

</div>

<ng-container *ngIf="gridView">


<div class="search_result" *ngIf="(isLoadingAddressBook$ | async) === false">
  <div class="result"
  *ngFor="let addressBook of searchedAddressBook"
  (click)="onView(addressBook)"
    style="cursor: pointer;"
  >
    <h2 class="name"><i class="ti-user"></i> {{ addressBook?.Name }}</h2>
    <div class="other-info">
      <p class="phone"><i class="ti-mobile"></i>{{ addressBook?.PhoneNo }}</p>
      <p class="email"><i class="ti-email"></i>{{ addressBook?.Email }}</p>
      <p class="account"><i class="ti-info-alt"></i>{{addressBook?.AccountName}}</p>
      <p class="number"><i class="ti-info-alt"></i>{{addressBook?.AccountNo}}</p>
    </div>
  </div>


</div>

</ng-container>

<div class="card mt-3 " *ngIf="listView">
  <div class="table-responsive" *ngIf="(isLoadingAddressBook$ | async) === false">
  <table class="table table-hover" >
    <thead>
      <tr>
        <th scope="col">S/N</th>
        <th scope="col">Name</th>
        <th scope="col">Phone Number</th>
        <th scope="col">Email</th>
        <th scope="col">Account Name</th>
        <th scope="col">AccountNo</th>
      </tr>
    </thead>
    <tbody >
      <tr  *ngFor="let addressBook of searchedAddressBook"
      (click)="onView(addressBook)" style="cursor: pointer;"
      >
        <th scope="row">{{i + 1}}</th>
        <td>{{ addressBook?.Name }}</td>
        <td>{{ addressBook?.PhoneNo }}</td>
        <td> {{ addressBook?.Email }}</td>
        <td>{{addressBook?.AccountName}}</td>
        <td>{{addressBook?.AccountNo}}</td>
      </tr>

    </tbody>
  </table>
</div>
</div>
</div>

<cradua-list-spinner
*ngIf="(isLoadingAddressBook$ | async) === true"
>
</cradua-list-spinner>
<!-- <pre>{{addressBook$ | async | json}}</pre> -->
